import BannerLayout from "../../../../layouts/bannerLayout";
import CalculatorResults from "../calculatorResults";
import CalculatorWebFilter from "./calculatorWebFilter";

const CalculatorWebLayout = ({
    navOption,
    formView,
    defaultData,
    backToFilterView,
    moveToFormView,
    buttonLoading,
    dropDownDataLoading,
    tourSitesAndActivities
}) => {
    return (
        <>
            {
                formView
                ?
                <BannerLayout 
                    navOptionIndex={navOption}
                    title="Plan Your Site Visits and Activity Pricing!" 
                    description="Instantly calculate total costs by combining site entrance fees, and activity rates in one place."
                    children={<CalculatorResults backToFilterView={backToFilterView}/>}
                />
                :
                <CalculatorWebFilter 
                    defaultData={defaultData} 
                    moveToFormView={moveToFormView}
                    buttonLoading={buttonLoading}
                    dropDownDataLoading={dropDownDataLoading}
                    tourSitesAndActivities={tourSitesAndActivities}
                />
            }
        </>
    );
}

export default CalculatorWebLayout;